import React, { useState, useEffect, useRef } from "react";
import Card from "../../components/card/Card";
import Vira from "../../components/vira/Vira";
import HideCard from "../../components/hideCard/HideCard";
import Scoreboard from "../../components/Scoreboard/Scoreboard";
import GameOutcomeModal from "../../components/gameOutcome/GameOutcomeModal";
import { useSelector, useDispatch } from "react-redux";
import { fetchGameState, playCard } from "../../redux/actions/game";
import { hapticHeavy } from "../../utils/haptic";
import avatar1 from "../../assets/images/avatar/avatar1.webp";
import avatar2 from "../../assets/images/avatar/avatar2.webp";
import avatar3 from "../../assets/images/avatar/avatar3.webp";
import avatar4 from "../../assets/images/avatar/avatar4.webp";
import avatar5 from "../../assets/images/avatar/avatar5.webp";
import avatar6 from "../../assets/images/avatar/avatar6.webp";
import avatar7 from "../../assets/images/avatar/avatar7.webp";
import avatar8 from "../../assets/images/avatar/avatar8.webp";
import avatar9 from "../../assets/images/avatar/avatar9.webp";
import avatar10 from "../../assets/images/avatar/avatar10.webp";
import avatar11 from "../../assets/images/avatar/avatar11.webp";
import avatar12 from "../../assets/images/avatar/avatar12.webp";
import "../../assets/styles/wild-west-icons.scss";
import "./Game.scss";

const avatarList = [avatar1, avatar2, avatar3, avatar4, avatar5, avatar6, avatar7, avatar8, avatar9, avatar10, avatar11, avatar12];

const Game = () => {
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const communication = useSelector((state) => state.communication);
  const { p1, p2, next_to_play_id, manilha } = game.state;

  const shouldFetch = useRef(true);
  const [avatars, setAvatars] = useState({ p1: null, p2: null });
  const [showOutcome, setShowOutcome] = useState(null);

  useEffect(() => {
    if (p1.game_score >= 12) {
      const t = setTimeout(() => setShowOutcome("victory"), 2000);
      return () => clearTimeout(t);
    }
    if (p2.game_score >= 12) {
      const t = setTimeout(() => setShowOutcome("defeat"), 2000);
      return () => clearTimeout(t);
    }
    setShowOutcome(null);
  }, [p1.game_score, p2.game_score]);

  useEffect(() => {
    const i1 = Math.floor(Math.random() * avatarList.length);
    let i2 = Math.floor(Math.random() * avatarList.length);
    while (i2 === i1) i2 = Math.floor(Math.random() * avatarList.length);
    setAvatars({ p1: avatarList[i1], p2: avatarList[i2] });
  }, []);

  useEffect(() => {
    if (shouldFetch.current) {
      shouldFetch.current = false;
      dispatch(fetchGameState());
      clearInterval(communication.fetchPlayersInQeueIntervalId);
    }
  }, [dispatch]);

  function myTurn() {
    return next_to_play_id === p1.id;
  }

  function shouldHideCard(card) {
    if (
      p1.first_play &&
      p2.first_play &&
      (p1.second_play || p2.second_play) &&
      (card === p1.first_play || card === p2.first_play)
    ) {
      return true;
    }

    if (
      p1.second_play &&
      p2.second_play &&
      (p1.third_play || p2.third_play) &&
      (card === p1.second_play || card === p2.second_play)
    ) {
      return true;
    }

    return false;
  }

  return (
    <div className="App game-table">
      <div className="container">
        <div className="hand rotate oponent">
          <HideCard hide={shouldHideCard(p2.cards[0].value + p2.cards[0].suit)}>
            <Card
              value={p2.cards[0].value}
              suit={p2.cards[0].suit}
              flipped={p2.cards[0].flipped}
              played={p2.cards[0].played}
            />
          </HideCard>
          <HideCard hide={shouldHideCard(p2.cards[1].value + p2.cards[1].suit)}>
            <Card
              value={p2.cards[1].value}
              suit={p2.cards[1].suit}
              flipped={p2.cards[1].flipped}
              played={p2.cards[1].played}
            />
          </HideCard>
          <HideCard hide={shouldHideCard(p2.cards[2].value + p2.cards[2].suit)}>
            <Card
              value={p2.cards[2].value}
              suit={p2.cards[2].suit}
              flipped={p2.cards[2].flipped}
              played={p2.cards[2].played}
            />
          </HideCard>
        </div>
        <div className="table-avatar-wrapper">
          <div className="table-avatar table-avatar--opponent">
            {avatars.p2 && <img alt="oponente" src={avatars.p2} />}
            <span className="table-avatar__name">{p2.name} ({p2.ranking_score})</span>
          </div>
          {
            manilha &&
            <div className="table">
            <Vira suit={manilha.suit} value={manilha.value}></Vira>
            <div className="deck card">
              <div className="card__back"></div>
            </div>
          </div>
          }
          <div className="table-avatar table-avatar--player">
            {avatars.p1 && <img alt="jogador" src={avatars.p1} />}
            <span className="table-avatar__name">{p1.name} ({p1.ranking_score})</span>
          </div>
        </div>
        <div className={`hand playerHand ${myTurn() ? "yourHand" : ""}`}>
          <HideCard hide={shouldHideCard(p1.cards[0].value + p1.cards[0].suit)}>
            <Card
              playAction={() =>
                { hapticHeavy(); dispatch(playCard(p1.cards[0].value, p1.cards[0].suit)); }
              }
              value={p1.cards[0].value}
              suit={p1.cards[0].suit}
              flipped={p1.cards[0].flipped}
              played={p1.cards[0].played}
            />
          </HideCard>
          <HideCard hide={shouldHideCard(p1.cards[1].value + p1.cards[1].suit)}>
            <Card
              playAction={() =>
                { hapticHeavy(); dispatch(playCard(p1.cards[1].value, p1.cards[1].suit)); }
              }
              value={p1.cards[1].value}
              suit={p1.cards[1].suit}
              flipped={p1.cards[1].flipped}
              played={p1.cards[1].played}
            />
          </HideCard>
          <HideCard hide={shouldHideCard(p1.cards[2].value + p1.cards[2].suit)}>
            <Card
              playAction={() =>
                { hapticHeavy(); dispatch(playCard(p1.cards[2].value, p1.cards[2].suit)); }
              }
              value={p1.cards[2].value}
              suit={p1.cards[2].suit}
              flipped={p1.cards[2].flipped}
              played={p1.cards[2].played}
            />
          </HideCard>
        </div>
      </div>
      <Scoreboard />

      {showOutcome === "victory" && <GameOutcomeModal outcome="victory" />}
      {showOutcome === "defeat" && <GameOutcomeModal outcome="defeat" />}
    </div>
  );
};

export default Game;
